// extracted by mini-css-extract-plugin
export default {"iconWrapper":"iconWrapper_iconWrapper__toLd7","iconWrapper_success":"iconWrapper_iconWrapper_success__SRZX4","iconWrapper_danger":"iconWrapper_iconWrapper_danger__HJEUV"};